<template>
    <v-container fluid class="bg-secondary fill-height">
        <v-row class="fill-height align-center justify-center">
            <v-card elevation="8" class="mx-auto pa-8 bg-primary rounded-xl" width="420px">
            <v-img :src="getImageUrl('logo-white')" alt="Logo" class="mx-auto mb-8" height="80" />
            
            <v-form @submit.prevent="submit">

                <v-text-field class="rounded-lg" ref="userNameField" v-model="userName" label="Username"
                    :prepend-inner-icon="icons.mdiAccount" autocomplete="off"
                    variant="outlined" density="compact" required 
                    @keyup.enter="submit">
                </v-text-field>

                <v-text-field class="rounded-lg" v-model="password" type="password" label="Password"
                    :prepend-inner-icon="icons.mdiLockOutline"
                    variant="outlined" required :error="passwordMismatch"
                    :error-messages="passwordMismatch ? [$t('toast.loginPasswordMismatch')] : []"
                    @keyup.enter="submit" autocomplete="off" density="compact">
                </v-text-field>

                <v-btn class="rounded-lg"type="submit" color="surface" variant="elevated" block :loading="loading"
                    :disabled="!isLoginValid">
                    {{ $t('action.logIn') }}
                </v-btn>

            </v-form>
        </v-card>
        </v-row>
    </v-container>
</template>

<script setup>
    import { computed, getCurrentInstance, nextTick, onMounted, ref, inject } from 'vue';
    import { mdiAccount, mdiLockOutline } from '@mdi/js';
    import { toast } from 'vue3-toastify';
    import { useLogStore } from '@/stores/logStore';
    import { useUserStore } from '@/stores/userStore';

    const urlWebAPI = inject('urlWebAPI');
    const getFormBody = inject('getFormBody');
    const logStore = useLogStore();
    const userStore = useUserStore();

    const instance = getCurrentInstance();
    const userName = ref('');
    const userNameField = ref(null);
    const password = ref('');
    const passwordMismatch = ref(false);
    const loading = ref(false);
    const icons = {
        mdiAccount,
        mdiLockOutline,
    };
    const isLoginValid = computed(() => userName.value !== '' && password.value !== '');

    onMounted(() => {
        nextTick(() => {
            userNameField.value?.focus();
        });
    });

    function submit() {
        if (!isLoginValid.value || loading.value)
            return;

        loading.value = true;
        passwordMismatch.value = false;

        const data = {
            userName: userName.value,
            password: password.value,
            customerId: 'Externis',
        };

        var formBody = getFormBody(data);

        fetch(urlWebAPI + 'Login', {
                    method: 'POST',
                    body: formBody,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    },
                })
                    .then(response => response.json())
                    .then(user => {
                        if (user != null) {
                            userStore.setUser(user);

                            getUserAdminInfo();
                        }
                        // USER NOT FOUND
                        else {
                            loading.value = false;
                            passwordMismatch.value = true;
                        }
                    })
                    .catch((error) => {
                        logStore.log(error, 'error');
                        toast.error('Error during executing login.', {theme: 'colored'})
                        loading.value = false;
                    });
    }

    function getUserAdminInfo() {
        const data = {
            userName: userName.value,
            password: password.value,
        };

        var formBody = getFormBody(data);

        fetch(urlWebAPI + 'GetUserAdminInfo', {
                    method: 'POST',
                    body: formBody,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    },
                })
                    .then(response => response.json())
                    .then(userAdminInfo => {
                        if (userAdminInfo != null) {
                            var user = userStore.getUser();

                            user['accessLevel'] = userAdminInfo.accessLevel;
                            user['distributorId'] = userAdminInfo.distributorId;
                            user['hasDistributor'] = user.distributorId > 0;

                            userStore.setUser(user);

                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
                        }
                    })
                    .catch((error) => {
                        logStore.log(error, 'error');
                        toast.error('Error during executing login.');
                        loading.value = false;
                    });
    }

    function getImageUrl(name, extension = 'png') {
        return new URL(`../assets/images/${name}.${extension}`, import.meta.url).href;
    }
</script>